import useActiveUsers from '@/features/agent/active_users/hooks/useActiveUsers';
import useCandidateProfileTags from '@/features/agent/candidates/hooks/useCandidateProfileTags';
import type { CandidateRecipientSelection } from '../hooks/useCandidateRecipientSelection';
import CandidateRecipientSelectModal from './CandidateRecipientSelectModal';

type MailRecipientPickerProps = {
  selection: CandidateRecipientSelection;
};

export default function MailRecipientPicker({ selection }: MailRecipientPickerProps) {
  const { data: activeUsersData } = useActiveUsers();
  const { data: candidateTagsData } = useCandidateProfileTags();

  return (
    <CandidateRecipientSelectModal
      open={selection.isPickerOpen}
      onClose={selection.closePicker}
      searchKeyword={selection.searchKeyword}
      onSearchKeywordChange={selection.setSearchKeyword}
      candidates={selection.candidates}
      selectedRecipients={selection.recipients}
      onToggleRecipient={selection.toggleRecipient}
      onClearSelections={selection.clearRecipients}
      onSelectAllVisible={selection.selectAllVisible}
      isLoading={selection.isLoading}
      isRefreshing={selection.isRefreshing}
      onLoadMore={selection.loadMore}
      hasNextPage={selection.hasNextPage}
      isFetchingNextPage={selection.isFetchingNextPage}
      errorMessage={selection.errorMessage}
      isEmpty={selection.isEmpty}
      totalCount={selection.totalCount}
      organizationUsers={activeUsersData?.activeUsers ?? []}
      selectedOrganizationUserId={selection.selectedOrganizationUserId}
      onSelectedOrganizationUserIdChange={selection.setSelectedOrganizationUserId}
      tagOptions={candidateTagsData?.tags ?? []}
      selectedTagIds={selection.selectedTagIds}
      onSelectedTagIdsChange={selection.setSelectedTagIds}
    />
  );
}
